angular.module('picmonic-common').controller('FooterController', [
  '$rootScope',
  '$scope',
  '$state',
  function ($rootScope, $scope, $state) {
    $scope.base_asset_url = $rootScope.base_asset_url;
    $scope.onPathways = $state.current.name.indexOf('app.pathways.market') > -1;
  },
]);
